import React, { useState } from 'react';
import styles from './LanguageSwitcher.module.scss';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { selectLanguage } from '../../store/auth/actions';
import { Popover } from '@material-ui/core';
import { StoreState } from '../../config/StoreProvider/StoreProvider';

type Props = {
  onSelectLanguage: (language: string) => void;
  selectedLanguage: string;
};

const LanguageSwitcher = ({ onSelectLanguage, selectedLanguage }: Props) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<any>(null);

  const LANGUAGES = [
    {
      label: 'LT',
      value: 'lt',
    },
    {
      label: 'EN',
      value: 'en',
    },
  ];

  const selectedLanguageOption = LANGUAGES.find(
    (language) => language.value === selectedLanguage,
  );

  const handleClick = (language: string) => {
    onSelectLanguage(language);
    setIsPopoverOpen(false);
  };

  const renderActions = () => {
    return LANGUAGES.map((language, index) => (
      <button
        className={styles.popoverListItem}
        key={index.toString()}
        onClick={() => handleClick(language.value)}
      >
        {language?.label}
      </button>
    ));
  };

  return (
    <>
      <div
        className={styles.switcherButton}
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
          setIsPopoverOpen(true);
        }}
      >
        {selectedLanguageOption?.label}
      </div>
      <Popover
        className={styles.popover}
        open={isPopoverOpen}
        onClose={() => setIsPopoverOpen(false)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div className={styles.popoverContent}>
          <ul className={styles.popoverList}>{renderActions()}</ul>
        </div>
      </Popover>
    </>
  );
};

const mapStateToProps = (state: StoreState) => ({
  selectedLanguage: state.auth.selectedLanguage,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  onSelectLanguage: (language: string) => dispatch(selectLanguage(language)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSwitcher);
